import HotelClassificationBusinessListResourceListResultModel from '../../generated/types/model/resource/HotelClassificationBusinessListResourceListResultModel';

export default class HotelClassificationBusinessListResourceListResultViewModel extends HotelClassificationBusinessListResourceListResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
